import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalAllowVersions = (({
  allowVersions,
  handleChangeAllowVersions,
}) => {
  const intl = useIntl();

  const disabled = !canUserManageShare();

  return (
    <div
      className="share-allow-versions share-setting"
    >
      <Label for="inpAllowVersions" className={classnames('switch', { disabled })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Show file versions' })}
          <HelpIcon id="share-allow-versions">
            {intl.formatMessage({ defaultMessage: 'Allow recipients to see file versions.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-allow-versions" simple={true} />
          {userHasFeature('share-allow-versions') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="allow-versions"
                id="inpAllowVersions"
                value={true}
                checked={allowVersions}
                disabled={disabled}
                onChange={handleChangeAllowVersions}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
    </div>
  );
});

ShareModalAllowVersions.propTypes = {
  allowVersions: PropTypes.bool.isRequired,
  handleChangeAllowVersions: PropTypes.func.isRequired,
};

export default ShareModalAllowVersions;
